import { computed, observable } from 'mobx';
import { autobind } from 'core-decorators';
import getLanguageByPath from '@src/utils/locale/getLanguageByPath';
import { LANGUAGE_CONFIGS } from '@src/constants/lang';

class LanguageSelectStore {
  /**
   * 可选择的语言列表
   * @type {[]}
   */
  @observable
  languageList = LANGUAGE_CONFIGS.map(item => ({
    language: item.name,
    languageKey: item.key
  }));
  /**
   * 是否展开列表
   * @type {boolean}
   */
  @observable isExpand = false;

  @computed
  get currentLanguageObject() {
    return this.languageList.find(item => item.languageKey === getLanguageByPath());
  }

  /**
   * 点击打开列表
   */
  @autobind
  onExpandListStatusChange(isExpand) {
    this.isExpand = typeof isExpand === 'boolean' ? isExpand : !this.isExpand;
  }

  /**
   * 跳转到指定语言
   * @param lang
   */
  @autobind
  onRedirectLanguage(lang) {
    const currentLanguage = getLanguageByPath();
    const newPath = window.location.pathname.replace(`/${currentLanguage}`, `/${lang}`);
    window.location.href = window.location.href.replace(window.location.pathname, newPath);
  }

  use() { }
}

export default LanguageSelectStore;
